// extracted by mini-css-extract-plugin
export var link = "styles-module__link___rUdv4";